import { Component } from 'react'
import { ShippingParcel, ShippingSelectData } from 'stylewhere/api'
import { Icons, List, RowProps, StatusChip } from 'stylewhere/components'
import { T, __ } from 'stylewhere/shared/i18n'
import { getDate, getAsnParcelStatusChip } from 'stylewhere/shared/utils'

interface Props extends RowProps {
  parcel: ShippingParcel
  onClick: () => void
  hideDate?: boolean
  isInbound?: boolean
  isPacking?: boolean
  canDelete?: boolean
  onDelete?: (parcel: ShippingSelectData, shipment: boolean) => void
}

export class ParcelListRow extends Component<Props> {
  onDelete = (e: React.MouseEvent) => {
    const { onDelete } = this.props
    e.stopPropagation()
    if (onDelete) {
      onDelete(this.props.parcel, false)
    }
  }

  render() {
    const { parcel, onClick, hideDate, isInbound, isPacking, canDelete } = this.props
    return (
      <List.Row mr={3} ml={3} pl={20} pr={20} pt={20} pb={20} onClick={onClick}>
        <List.Cell maxWidth={'18%'} p={5} label={__(T.misc.parcel)} value={parcel.code} />
        {!isPacking && <List.Cell maxWidth={'18%'} p={5} label={__(T.misc.shipment)} value={parcel.asn?.code ?? '-'} />}
        <List.Cell flex={0} width={240} p={5} label={__(T.misc.status)}>
          <StatusChip
            status={parcel.status || '?'}
            customStatusType={getAsnParcelStatusChip(parcel.status ?? '')}
            pv={1}
            fontSize={16}
          />
        </List.Cell>
        {!isPacking && (
          <List.Cell
            p={5}
            flex={1}
            label={isInbound ? __(T.misc.origin) : __(T.misc.destination)}
            value={
              isInbound
                ? parcel.asn?.originPlace?.description || '--'
                : parcel.asn?.destinationPlace?.description || '--'
            }
          />
        )}
        {!hideDate && (
          <List.Cell
            maxWidth={200}
            p={5}
            label={__(T.misc.creation_date)}
            value={parcel.creationDate ? getDate(new Date(parcel.creationDate).getTime()) : '--'}
          />
        )}
        <List.Cell
          flex={0}
          width={80}
          p={5}
          label={__(T.misc.read)}
          value={
            parcel.checklistId && parcel.checklistId !== null
              ? `${parcel.parcelEntryQuantity}/${parcel.checklistExpectedQuantity ?? 0}`
              : `${parcel.parcelEntryQuantity}`
          }
        />
        <List.Cell flex={0} width={50} p={5}>
          {canDelete && <Icons.Trash width={24} height={24} onClick={this.onDelete} />}
        </List.Cell>
      </List.Row>
    )
  }
}
